// Match suggestions and display calculations. Betting writes use bettingApi.js.




// Competitions to fetch from football-data.org (free tier)
const FOOTBALL_DATA_COMPETITIONS = {
  PL: { code: 'PL', name: 'Premier League', abbr: 'pl' },
  CL: { code: 'CL', name: 'Champions League', abbr: 'cl' },
  BL1: { code: 'BL1', name: 'Bundesliga', abbr: 'bl' },
  SA: { code: 'SA', name: 'Serie A', abbr: 'sa' },
  PD: { code: 'PD', name: 'La Liga', abbr: 'pd' },
  FL1: { code: 'FL1', name: 'Ligue 1', abbr: 'fl' },
};

function matchOptions(homeTeam, awayTeam) {
  return [
    { name: `${homeTeam} Win`, odds: null },
    { name: 'Draw', odds: null },
    { name: `${awayTeam} Win`, odds: null },
  ];
}

async function fetchLiveFootballMatches() {
  if (!process.env.REACT_APP_FOOTBALL_DATA_API_KEY) return [];
  // Fetch upcoming matches from football-data.org (free tier, 10 req/min)
  const today = new Date();
  const dateFrom = today.toISOString().split('T')[0];
  const dateTo = new Date(today.getTime() + 14 * 86400000).toISOString().split('T')[0];

  const results = [];
  const competitionCodes = Object.keys(FOOTBALL_DATA_COMPETITIONS);

  // Fetch from multiple competitions in parallel
  const responses = await Promise.allSettled(
    competitionCodes.map(async (code) => {
      const url = `https://api.football-data.org/v4/competitions/${code}/matches?dateFrom=${dateFrom}&dateTo=${dateTo}&status=SCHEDULED,TIMED`;
      const resp = await fetch(url, {
        headers: { 'X-Auth-Token': process.env.REACT_APP_FOOTBALL_DATA_API_KEY || '' },
      });
      if (!resp.ok) return [];
      const data = await resp.json();
      return (data.matches || []).map((m) => ({
        competition: FOOTBALL_DATA_COMPETITIONS[code],
        match: m,
      }));
    })
  );

  for (const result of responses) {
    if (result.status === 'fulfilled' && result.value) {
      results.push(...result.value);
    }
  }

  // Sort by date and take the next ~8 matches
  results.sort((a, b) => new Date(a.match.utcDate) - new Date(b.match.utcDate));
  const upcoming = results.slice(0, 8);

  return upcoming.map(({ competition, match }) => {
    const home = match.homeTeam?.shortName || match.homeTeam?.name || 'Home';
    const away = match.awayTeam?.shortName || match.awayTeam?.name || 'Away';
    const matchDate = new Date(match.utcDate);
    const dateStr = matchDate.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

    return {
      source: `${competition.name} — ${dateStr}`,
      matchName: `${home} vs ${away}`,
      matchDate: match.utcDate,
      type: 'match_result',
      competition: competition.abbr,
      suggestion: `${competition.name} match on ${dateStr}`,
      options: matchOptions(home, away),
    };
  });
}

export const apiService = {
  async getSuggestedMarkets() {
    try {
      const matches = await fetchLiveFootballMatches();
      if (matches && matches.length > 0) {
        console.log(`[api] Fetched ${matches.length} live matches from football API`);
        return matches;
      }
    } catch (err) {
      console.warn('[api] Live football suggestions are unavailable:', err);
    }
    return [];
  },

  // ========== CALCULATIONS ==========
  calculateLivePotential(userId, bets, markets) {
    const userBets = bets.filter((b) => b.userId === userId && b.status === 'pending');
    const totalStaked = userBets.reduce((sum, b) => sum + b.amount, 0);
    const totalPotentialWin = userBets.reduce((sum, b) => sum + b.potentialWin, 0);
    const avgOdds = userBets.length > 0
      ? userBets.reduce((sum, b) => sum + (b.odds || b.potentialWin / b.amount), 0) / userBets.length
      : 0;

    return {
      activeBets: userBets.length,
      totalStaked,
      totalPotentialWin,
      potentialProfit: totalPotentialWin - totalStaked,
      avgOdds: Math.round(avgOdds * 100) / 100,
    };
  },


};
